module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_central-florida-d46972b6b090e3636fb3057b5775b7ae.png";